import React, { useEffect, useCallback } from 'react'
import * as Analytics from 'analytics/analytics'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Image from 'components/Common/Image'
import TextLink from 'components/Luxkit/TextLink'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import { fetchDreamSiteBlogPost } from 'actions/ContentActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import DreamArticleUSPSkeleton from './DreamArticleUSPSkeleton'
import qs from 'qs'
import { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'

const ImageWrapper = styled.div`
  min-width: 68px;
  height: 68px;

  ${mediaQueryUp.tablet} {
    min-width: 84px;
    height: 84px;
  }
`
interface Props {
  dreamArticleId: string;
}

const query = qs.stringify({
  utm_source: 'offer-page',
})

function DreamArticleUSP({ dreamArticleId }: Props) {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(fetchDreamSiteBlogPost(dreamArticleId))
    // eslint-disable-next-line
  }, [])

  const handleClick = useCallback(() => {
    Analytics.trackClientEvent({
      subject: 'click_dream_article',
      action: dreamArticleId,
      category: AnalyticsPage.offerPage,
      type: 'interaction',
      optimizelyEventId: '5890422782820352',
      optimizelyEventKey: 'offer_page_dream_article_clicked',
    })
  }, [dreamArticleId])

  const blogPost = useAppSelector(state => state.content.dreamSiteBlogPost[dreamArticleId])

  if (!blogPost?.data) {
    return null
  }
  if (blogPost.fetching) {
    return <DreamArticleUSPSkeleton/>
  }
  const dreamArticleUrl = blogPost.data?.url + '?' + query

  return (
    <Group
      gap={16}
      tabletGap={20}
      direction="horizontal-reverse"
      tabletDirection="horizontal"
      verticalAlign="start"
      tabletVerticalAlign="center"
      horizontalAlign="space-between"
      tabletHorizontalAlign="start"
    >
      <ImageWrapper>
        <Image fit="top" image={blogPost.data.image} quality="best" />
      </ImageWrapper>
      <Group direction="vertical" gap={4}>
        <BodyText variant="small" weight="normal" colour="neutral-two" format="uppercase">
          inspiration
        </BodyText>
        <BodyText variant="medium" weight="bold">
          {blogPost.data.title}
        </BodyText>
        <BodyText variant="medium" colour="neutral-three" lineClamp={2}>
          {blogPost.data.shortDescription}
        </BodyText>
        <Group direction="horizontal" gap={32}>
          <TextLink
            size="medium"
            weight="bold"
            href={dreamArticleUrl}
            target="_blank"
            onClick={handleClick}
          >
            View article
          </TextLink>
        </Group>
      </Group>
    </Group>
  )
}

export default DreamArticleUSP
